export class StoreBase {
  constructor(rootStore, inital = {}) {
    Object.assign(this, inital)
    this.rootStore = rootStore
  }
  reset() {
    // Should override this function
  }
}
